export default {
  state: {
    filtroGenerico: new Map()
  },
  mutations: {
    setFiltroGenerico(state, _filtro) {
      state.filtroGenerico.set(_filtro.codigo, _filtro.objeto);
    }
  },
  getters: {
    getFiltroGenerico: state => state.filtroGenerico
  }
};
